import type { TableProps } from 'antd';
import type React from 'react';
import { useMemo } from 'react';

type AntdColumnRender<T> = NonNullable<
  NonNullable<TableProps<T>['columns']>[number]['render']
>;

type ColumnConfig<T> = {
  key: string;
  title: string | React.ReactNode;
  width?: string | number;
  align?: 'left' | 'center' | 'right';
  render?: AntdColumnRender<T>;
  onCell?: (record: T, index?: number) => object;
};

export const useTableColumns = <T extends object>(
  columnsConfig: ColumnConfig<T>[]
): TableProps<T>['columns'] => {
  return useMemo(
    () =>
      columnsConfig.map((config) => ({
        key: config.key,
        dataIndex: config.key,
        title: config.title,
        width: config.width,
        align: config.align,
        render: config.render,
        onCell: config.onCell,
      })),
    [columnsConfig]
  );
};
